import {Component, DestroyRef, OnInit, inject, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {CommonModule} from '@angular/common';
import {forkJoin} from 'rxjs';
import {EcuBuildStats} from '../../models/dashboard-statistics.model';
import {DashboardStatisticsService} from '../../services/dashboard-statistics.service';

@Component({
  selector: 'app-ecu-matching-breakdown',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ecu-matching-breakdown.component.html',
  styleUrls: ['./ecu-matching-breakdown.component.css']
})
export class EcuMatchingBreakdownComponent implements OnInit {

  private readonly statsService = inject(DashboardStatisticsService);
  private readonly destroyRef = inject(DestroyRef);

  missingMatching: EcuBuildStats[] = [];
  partialMatching: EcuBuildStats[] = [];
  successfulMatching: EcuBuildStats[] = [];
  isLoading = signal<boolean>(true);

  ngOnInit(): void {
    forkJoin({
      missing: this.statsService.getMissingMatchingByEcuBuild(),
      partial: this.statsService.getPartialMatchingByEcuBuild(),
      successful: this.statsService.getSuccessfulMatchingByEcuBuild()
    })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({missing, partial, successful}) => {
          this.missingMatching = missing;
          this.partialMatching = partial;
          this.successfulMatching = successful;
          this.isLoading.set(false);
        },
        error: () => this.isLoading.set(false)
      });
  }

  getMaxValue(items: EcuBuildStats[]): number {
    if (!items || !items.length) return 1;
    return Math.max(...items.map(i => i.count), 1);
  }

  getBarWidth(count: number, items: EcuBuildStats[]): number {
    const max = this.getMaxValue(items);
    return (count / max) * 100;
  }
}
